import React, { useState } from 'react';

const WEB3FORMS_URL = 'https://api.web3forms.com/submit';

const Contact = ({ data }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [formStatus, setFormStatus] = useState('idle');
    const [errorText, setErrorText] = useState('');

    if (data) {
        var contactName = data.name;
        var state = data.address.state;
        var country = data.address.country;
        var phone = data.phone;
        var contactEmail = data.email;
        var contactMessage = data.contactmessage;
    }

    const accessKey = process.env.REACT_APP_WEB3FORMS_ACCESS_KEY;

    const submitForm = async (e) => {
        e.preventDefault();
        setFormStatus('idle');
        setErrorText('');

        if (!name.trim() || !email.trim() || !message.trim()) {
            setErrorText('Please fill in name, email, and message.');
            setFormStatus('error');
            return;
        }

        if (!accessKey) {
            setErrorText(
                'Contact form is not configured. Set REACT_APP_WEB3FORMS_ACCESS_KEY in a .env file (see README).',
            );
            setFormStatus('error');
            return;
        }

        setFormStatus('sending');

        try {
            const res = await fetch(WEB3FORMS_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                body: JSON.stringify({
                    access_key: accessKey,
                    name,
                    email,
                    subject:
                        subject.trim() ||
                        `Portfolio contact from ${name || email}`,
                    message: `From: ${name} <${email}>\n\n${message}`,
                    from_name: name,
                    replyto: email,
                }),
            });
            const json = await res.json();

            if (json.success) {
                setFormStatus('success');
                setName('');
                setEmail('');
                setSubject('');
                setMessage('');
            } else {
                setErrorText(json.message || 'Something went wrong. Try again.');
                setFormStatus('error');
            }
        } catch {
            setErrorText('Network error. Check your connection and try again.');
            setFormStatus('error');
        }
    };

    return (
        <section id="contact">
            <div className="row section-head">
                <div className="two columns header-col">
                    <h1>
                        <span>Get In Touch.</span>
                    </h1>
                </div>

                <div className="ten columns">
                    <p className="lead">{contactMessage}</p>
                </div>
            </div>

            <div className="row">
                <div className="eight columns">
                    <form onSubmit={submitForm}>
                        <fieldset>
                            <div>
                                <label htmlFor="contactName">
                                    Name <span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    value={name}
                                    size="35"
                                    id="contactName"
                                    name="contactName"
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>

                            <div>
                                <label htmlFor="contactEmail">
                                    Email <span className="required">*</span>
                                </label>
                                <input
                                    type="email"
                                    value={email}
                                    size="35"
                                    id="contactEmail"
                                    name="contactEmail"
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>

                            <div>
                                <label htmlFor="contactSubject">Subject</label>
                                <input
                                    type="text"
                                    value={subject}
                                    size="35"
                                    id="contactSubject"
                                    name="contactSubject"
                                    onChange={(e) => setSubject(e.target.value)}
                                />
                            </div>

                            <div>
                                <label htmlFor="contactMessage">
                                    Message <span className="required">*</span>
                                </label>
                                <textarea
                                    cols="50"
                                    rows="15"
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    id="contactMessage"
                                    name="contactMessage"
                                ></textarea>
                            </div>

                            <div>
                                <button
                                    type="submit"
                                    className="submit"
                                    disabled={formStatus === 'sending'}
                                >
                                    {formStatus === 'sending'
                                        ? 'Sending…'
                                        : 'Submit'}
                                </button>
                            </div>
                        </fieldset>
                    </form>

                    <div
                        id="message-warning"
                        style={{
                            display: formStatus === 'error' ? 'block' : 'none',
                        }}
                    >
                        {errorText}
                    </div>
                    <div
                        id="message-success"
                        style={{
                            display:
                                formStatus === 'success' ? 'block' : 'none',
                        }}
                    >
                        <i className="fa fa-check"></i>Your message was sent,
                        thank you!
                        <br />
                    </div>
                </div>

                <aside className="four columns footer-widgets">
                    <div className="widget widget_contact">
                        <h4>Address and Phone</h4>
                        <p className="address">
                            {contactName}
                            <br />
                            {contactEmail}
                            <br />
                            {state}, {country}
                            <br />
                            <span>{phone}</span>
                        </p>
                    </div>
                </aside>
            </div>
        </section>
    );
};

export default Contact;
